const DonationWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const DonationTab = () => import('../pages/Donation/DonationTab');
const DonationDetail = () => import('../pages/PartyMembershipDues/PmdDetailsEmpty');
const DonationChargeSchedule = () => import('../pages/PartyMembershipDues/PmdChargeSchedule');
const DonationControl = () => import('../pages/PartyMembershipDues/PmdControl');
const DonationAuditRecords = () => import('../pages/PartyMembershipDues/PmdAuditRecords');
const DonationTicketManage = () => import('../components/otherTicketManage');

export default [
	{ path: '/DonationHomePage', name: 'DonationHomePage', component: DonationWrapper, meta: { type: 'donation' } },
	{
		path: '/DonationTab',
		component: DonationTab,
		children: [
			{ path: '/', name: 'DonationDetailsEmpty', component: DonationDetail, meta: { parent: '/DonationHomePage' } },
			{ path: 'DonationProgress', name: 'DonationProgress', component: DonationChargeSchedule, meta: { parent: '/DonationHomePage' } },
			{ path: 'DonationControl', name: 'DonationControl', component: DonationControl, meta: { parent: '/DonationHomePage' } },
			{ path: 'DonationAuditRecords', name: 'DonationAuditRecords', component: DonationAuditRecords, meta: { parent: '/DonationHomePage' } },
			{ path: 'DonationTicketManage', name: 'DonationTicketManage', component: DonationTicketManage, meta: { parent: '/DonationHomePage' } },
		],
	},
];
